import React, { Fragment } from 'react';

import {
  BulmaHero
} from '../../components/HelperComponents/HelperComponents';

import {
  ThankYouH1,
  ThankYouH2,
  NabvarIcon,
  HoverLink
} from '../../components/HelperComponents/StyledComponents';

import BackgroundImage from '../../images/background.png';

const HeroBody = () => (
  <Fragment>
    <section className="container">
      <section className="columns is-centered">
        <section className="column is-6 has-text-white">
          <ThankYouH1 className="title is-1 has-text-white">About Us</ThankYouH1>
          <ThankYouH2 className="is-size-4">Voila. Music that belongs.</ThankYouH2>
          <p style={{ marginTop: '15px' }}>
            Voila is an unparalleled music library built specifically for advertising. To meet the demand for fast turn around in post-production, Voila has invested in exceptional live recordings that can be provided to advertisers instantaneously and customized to order.
          </p>
          <hr />
          <section className="">
            <div className="is-pulled-left" style={{ paddingRight: '3rem', marginBottom: '1rem' }}>
              <NabvarIcon className="icon-pin" />
              <div className="is-pulled-right">
                <h2 className="title is-3 has-text-white has-text-weight-light" style={{ margin: '0', whiteSpace: 'nowrap'}}>
                  Los Angeles
                </h2>
                <p>
                  <HoverLink href="mailto:hello@voilacatalog.com?subject=hello"
                    rel="noopener noreferrer"
                    target="_blank"
                  >hello@voilacatalog.com</HoverLink>
                </p>
                <p>310-383-4139</p>
              </div>
            </div>
            <div className="is-pulled-left">
              <NabvarIcon className="icon-pin" />
              <div className="is-pulled-right">
                <h2 className="title is-3 has-text-white has-text-weight-light" style={{ margin: '0', whiteSpace: 'nowrap'}}>
                  New York
                </h2>
                <p>
                  <HoverLink href="mailto:hello@voilacatalog.com?subject=hello"
                    rel="noopener noreferrer"
                    target="_blank"
                  >hello@voilacatalog.com</HoverLink>
                </p>
                <p>718-260-8622</p>
              </div>
            </div>
          </section>
        </section>
      </section>
    </section>
  </Fragment>
);

export const AboutUs = () => (
  <BulmaHero heroSize="is-fullheight" activateBodyPadding={true} body={<HeroBody />} image={BackgroundImage}></BulmaHero>
);



// WEBPACK FOOTER //
// ./src/routes/AboutUs/AboutUs.js